module.exports = __webpack_public_path__ + "static/img/advantage-bg.cd0e1b34.png";